<template>
  <div>
    <!--begin::Content header-->
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Iniciar Sesión</h3>
        <span>Inicia sesión con tu cuenta empresa</span>
        </div>

        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <div class="form-label-group">
          <label for="inputRut">Rut Usuario</label>
          <b-form-input
            class="form-control"
            id="example-input-1"
            name="example-input-1"
            placeholder="Ingrese su Rut"
            v-model="$v.form.rut.$model"
            :state="validateState('rut')"
            aria-describedby="input-1-live-feedback" autofocus
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            Rut es requerido y debe ser valido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group">
          <label for="inputPassword">Contraseña</label>
          <b-form-input
            class="form-control"
            type="password"
            id="example-input-2"
            name="example-input-2"
            placeholder="Ingrese su Contraseña"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Contraseña es requerida.
          </b-form-invalid-feedback>
          </div>
       
        <!--begin::Action-->
         <button
            ref="kt_login_signin_submit"
            class="btn btn-primary align-self-center"
          >
            Ingresar
          </button>

        <p class="mt-3 mb-3 text-muted text-center">
          <router-link
                          class="text-dark-60 text-hover-primary my-3 mr-2"
                          :to="{ name: 'recovery-executive' }"
                        >
           ¿Has olvidado tu contraseña?
          </router-link>
        </p>
        <div 
          class="text-right mb-lg-0 flex-column-auto justify-content-center py-2 px-0"
        >
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { LOGIN_EXECUTIVE, LOGOUT } from "@/core/services/store/auth.module";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";
Vue.use(VueReCaptcha, { siteKey: '6LfhajsaAAAAAOmttdUAzgYkTvd2HxXUgmT5KTT8' })

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        rut: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      rut: {
        required,
       // rut
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()   
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const rut = this.$v.form.rut.$model;
      const contrasena = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const token = await this.$recaptcha('login')  

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN_EXECUTIVE, { rut, contrasena, token })
          // go to which page after successfully login
          .then((response) => {
            if(response.bloqueado){
              this.$router.push({ name: "block-executive" });
            } else if(response.debeCambiarClave){
              this.$router.push({ name: "changePassword-executive", params: { token: response.tokenUsuario }  });
            } else {
              this.$router.push({ name: "statistics" });
            }
          });

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>